import { useNavigate } from 'react-router-dom';
import { Button, StatusBadge } from '../../components/core';
import { type Column } from '../../components/feedback';
import { ReportList } from './ReportList';

interface StreamRow {
  id: string;
  name: string;
  tenantId: string;
  tenantName: string;
  status: string;
  startedAt: string | null;
  createdAt: string;
}

const when = (iso: string | null) =>
  iso ? new Date(iso).toLocaleString('en-IN', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }) : '—';

const columns: Column<StreamRow>[] = [
  { key: 'name', header: 'Stream', render: (r) => <span className="font-medium">{r.name}</span> },
  { key: 'tenant', header: 'Tenant', render: (r) => <span className="text-muted text-sm">{r.tenantName}</span> },
  { key: 'status', header: 'Status', render: (r) => <StatusBadge status={r.status} /> },
  { key: 'started', header: 'Started', render: (r) => <span className="text-muted text-sm">{when(r.startedAt)}</span> },
  { key: 'created', header: 'Created', render: (r) => <span className="text-muted text-sm">{when(r.createdAt)}</span> },
];

const STATUS_FILTER = [
  { value: '', label: 'All statuses' },
  { value: 'LIVE', label: 'Live' },
  { value: 'OFFLINE', label: 'Offline' },
  { value: 'ERROR', label: 'Error' },
];

export function AdminStreamsPage() {
  const navigate = useNavigate();
  return (
    <ReportList<StreamRow>
      title="Streams"
      subtitle="Every stream across every tenant"
      endpoint="/api/admin/streams"
      searchPlaceholder="Search stream names…"
      filters={[{ key: 'status', label: 'Stream status', options: STATUS_FILTER }]}
      columns={columns}
      emptyText="No streams yet."
      actions={<Button variant="secondary" onClick={() => navigate('/admin/tenants')}>Manage tenants</Button>}
      csv={{
        filename: 'streams.csv',
        header: ['Stream', 'Tenant', 'Status', 'Started', 'Created'],
        toRow: (r) => [r.name, r.tenantName, r.status, r.startedAt, r.createdAt],
      }}
    />
  );
}